export default __webpack_public_path__ + "static/media/arrow-left-c.dfa72b3a.svg";